import React from 'react';

const feedbackEmail =
  process.env.REACT_APP_FEEDBACK_EMAIL || 'hello@askartie.net';

const Footer = () => {
  return (
    <footer className="bg-white border-t border-slate-200 mt-16">
      <div className="max-w-7xl mx-auto px-4 py-8">
        <div className="flex flex-col md:flex-row justify-between items-center gap-4">
          <div className="text-slate-600 text-sm">
            © {new Date().getFullYear()} Ask Artie. Discover art and culture near you.
          </div>
          <div className="flex items-center gap-6">
            <a
              href={`mailto:${feedbackEmail}`}
              className="text-slate-600 hover:text-brand text-sm transition-colors"
            >
              Say hello
            </a>
            {process.env.REACT_APP_FEEDBACK_URL && (
              <a
                href={process.env.REACT_APP_FEEDBACK_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="text-slate-600 hover:text-brand text-sm transition-colors"
              >
                Feedback
              </a>
            )}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
